import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ShieldCheck } from "lucide-react";

/** PayTR iFrame ödeme sayfası — kart bilgileri yalnızca PayTR'nin güvenli
 * sayfasında girilir; Bigeldi'ye hiçbir kart verisi ulaşmaz. */
export default function PaytrPayPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!token) setFailed(true);
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAF9F5] py-8 px-4">
      <Helmet><title>Güvenli Ödeme | BIGELDİ</title></Helmet>
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-2 mb-4 text-sm text-neutral-600">
          <ShieldCheck size={16} className="text-emerald-600" />
          256-bit SSL ile korunan PayTR güvenli ödeme sayfası
        </div>
        {failed ? (
          <div className="bg-white border border-[#E6E4DD] rounded-2xl p-10 text-center" data-testid="paytr-error">
            <p className="font-display font-bold text-lg text-[#121214]">Ödeme oturumu bulunamadı</p>
            <p className="text-sm text-neutral-500 mt-2">Bağlantı süresi dolmuş olabilir. Lütfen siparişinizi tekrar oluşturun.</p>
          </div>
        ) : (
          <div className="bg-white border border-[#E6E4DD] rounded-2xl overflow-hidden" data-testid="paytr-iframe-wrap">
            <iframe title="PayTR Güvenli Ödeme" data-testid="paytr-iframe"
              src={`https://www.paytr.com/odeme/guvenli/iframe_token?token=${encodeURIComponent(token)}`}
              className="w-full border-0" style={{ minHeight: "720px" }} />
          </div>
        )}
      </div>
    </div>
  );
}
